import { render, staticRenderFns } from "./BackofficeMainView.vue?vue&type=template&id=a952b676"
import script from "./BackofficeMainView.vue?vue&type=script&lang=js"
export * from "./BackofficeMainView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports